// extracted by mini-css-extract-plugin
module.exports = {"navbar":"navbar-module--navbar--3K-e1","active":"navbar-module--active--2Saxi","light":"navbar-module--light--Xmh5o"};